import React from 'react'
import Hubnav from './Hubnav'
import { useNavigate } from 'react-router-dom';
const DistributionHubPanel = () => {
    var nav=useNavigate()
    function navOrders(){
        nav('/DistributionHubPanel/HubOrders')
    }
    function navDeliveryBoyConfig(){
            nav('/DistributionHubPanel/DeliveryBoyConifg')
    }
  return (
     <>
      <Hubnav/>
      <div className="card h-100 text-center panel" id='panel1'>
        <div className="card-body row ">
        <i className="fas fa-users-cog icon col" onClick={()=>navDeliveryBoyConfig()}></i>
          <i className="fas fa-truck icon col" onClick={()=>navOrders()}></i>
        </div>
        <div className="card-body row content">
          <b className="col" style={{ paddingLeft: "3.0px" }} >Delivery Boy Configuration</b>
          <b className="col">Orders</b>
        </div>
      </div>
     </>
  )
}

export default DistributionHubPanel